import { render, staticRenderFns } from "./ClientsStatisticElement.vue?vue&type=template&id=4fa12f39&scoped=true"
import script from "./ClientsStatisticElement.vue?vue&type=script&lang=js"
export * from "./ClientsStatisticElement.vue?vue&type=script&lang=js"
import style0 from "./ClientsStatisticElement.vue?vue&type=style&index=0&id=4fa12f39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa12f39",
  null
  
)

export default component.exports